/**
 * reply-loyalty-pricing
 * Logic for client-side validation and variant selection protection.
 */

(function () {
  ("use strict");

  /* ToDo: Check the former disabled logic for variantes with non eligible ids. For now, we skip this disabled attribute */
  const DISABLE_ADD_TO_CART_CHECK = true;

  class ReplyLoyaltyPricing {
    constructor() {
      this.productForms = /** @type {HTMLFormElement[]} */ (
        Array.from(document.querySelectorAll('form[action="/cart/add"]'))
      );
      this.variantPicker = document.querySelector(
        "variant-selects, variant-radios",
      );
      this.eligibleVariants = this.getEligibleVariants();

      if (this.eligibleVariants.length > 0 && this.productForms.length > 0) {
        this.init();
      }
    }

    getEligibleVariants() {
      const scriptTag = document.querySelector("#reply-loyalty-pricing-data");
      if (scriptTag) {
        try {
          return JSON.parse(scriptTag.textContent).eligibleVariantIds || [];
        } catch (e) {
          // Silent fail
        }
      }
      return [];
    }

    init() {
      if (this.variantPicker) {
        this.variantPicker.addEventListener(
          "change",
          this.handleVariantChange.bind(this),
        );
      }

      for (const form of this.productForms) {
        form.addEventListener("submit", this.handleFormSubmit.bind(this));
      }

      // Initial check
      this.validateCurrentVariant();
    }

    /**
     * @param {Event} event
     */
    handleVariantChange(event) {
      // Wait one render tick so variant input state is up to date before validation.
      requestAnimationFrame(() => {
        this.validateCurrentVariant();
      });
    }

    validateCurrentVariant() {
      if (DISABLE_ADD_TO_CART_CHECK) return;

      for (const form of this.productForms) {
        const selectedVariantId = this.getSelectedVariantId(form);
        if (!selectedVariantId) continue;
        const isEligible = this.eligibleVariants.includes(
          Number(selectedVariantId),
        );
        this.disableAddToCart(form, !isEligible);
      }
    }

    /**
     * @param {HTMLFormElement} form
     * @returns {string|null}
     */
    getSelectedVariantId(form) {
      const input = /** @type {HTMLInputElement|null} */ (
        form ? form.querySelector('input[name="id"]') : null
      );
      return input ? input.value : null;
    }

    /**
     * @param {HTMLFormElement} form
     * @param {boolean} disabled
     */
    disableAddToCart(form, disabled) {
      const submitButton = /** @type {HTMLButtonElement|null} */ (
        form.querySelector('[name="add"]')
      );
      if (submitButton) {
        submitButton.disabled = disabled;
        if (disabled) {
          submitButton.classList.add("disabled");
        } else {
          submitButton.classList.remove("disabled");
        }
      }
    }

    /**
     * @param {SubmitEvent} event
     */
    handleFormSubmit(event) {
      if (DISABLE_ADD_TO_CART_CHECK) return;

      const form = /** @type {HTMLFormElement|null} */ (event.currentTarget);
      if (!form) return;
      const selectedVariantId = this.getSelectedVariantId(form);
      if (
        selectedVariantId &&
        !this.eligibleVariants.includes(Number(selectedVariantId))
      ) {
        event.preventDefault();
        alert(
          "This variant is not available for purchase with your loyalty status.",
        );
        return false;
      }
    }
  }

  // Initialize on DOMContentLoaded
  document.addEventListener("DOMContentLoaded", () => {
    new ReplyLoyaltyPricing();
  });
})();
